import React from 'react';
import content from '../data/content';

export default function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero-bg">
        <img
          src="/images/AdobeStock_520187150-p-1600.jpeg"
          alt="IT Consulting"
        />
      </div>
      <div className="hero-content">
        <div className="hero-badge">
          <span className="dot" />
          Offen für neue Projekte 2026
        </div>
        <h1>{content.hero.headline}</h1>
        <p>{content.hero.subline}</p>
        <div className="hero-tags">
          {content.hero.tags.map((tag) => (
            <span key={tag} className="hero-tag">{tag}</span>
          ))}
        </div>
        <div className="hero-actions">
          <a href="#/kontakt" className="btn btn-primary">
            Kontakt aufnehmen
          </a>
          <a href="#services" className="btn btn-outline"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Unsere Leistungen →
          </a>
        </div>
      </div>
    </section>
  );
}
